var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 186,
    viewBox: "0 0 124 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9872 0L54.0701 3.14389V94.3721L54.9872 95.2955L96.9747 70.2642L54.9872 0Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9875 0L13 70.2642L54.9875 95.2958V51.0163V0Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9872 103.314L54.4704 103.949V136.447L54.9872 137.969L96.9997 78.295L54.9872 103.314Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9875 137.969V103.313L13 78.2943L54.9875 137.969Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9872 95.2955L96.9741 70.2645L54.9872 51.0166V95.2955Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 70.2645L54.9872 95.2955V51.0166L13.0003 70.2645Z",
    fill: "#393939"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.64 180H5.04V160.4L8.96 156.48H5.04V152.56H24.64V156.48H9.52V167.68L12.88 164.32H24.64V168.24H9.52V176.08H24.64V180ZM56.56 180H52.08V172.16H37.52V180H33.04V156.48C33.04 155.397 33.4133 154.483 34.16 153.736C34.944 152.952 35.8773 152.56 36.96 152.56H56.56V180ZM52.08 168.24V156.48H37.52V171.6L40.88 168.24H52.08ZM85.0981 176.08C85.0981 177.163 84.7061 178.096 83.9221 178.88C83.1755 179.627 82.2608 180 81.1781 180H65.4981V176.08H80.6181V168.24H69.4181C68.3355 168.24 67.4021 167.867 66.6181 167.12C65.8715 166.336 65.4981 165.403 65.4981 164.32V156.48C65.4981 155.397 65.8715 154.483 66.6181 153.736C67.4021 152.952 68.3355 152.56 69.4181 152.56H85.0981V156.48H69.9781V164.32H81.1781C82.2608 164.32 83.1755 164.712 83.9221 165.496C84.7061 166.243 85.0981 167.157 85.0981 168.24V176.08ZM116.471 168.24C116.471 169.323 116.079 170.256 115.295 171.04C114.549 171.787 113.634 172.16 112.551 172.16H106.951V180H102.471V172.16H96.8713C95.7886 172.16 94.8553 171.787 94.0713 171.04C93.3246 170.256 92.9513 169.323 92.9513 168.24V152.56H97.4313V168.24H111.991V152.56H116.471V168.24Z",
    fill: "url(#paint0_linear_2_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_27",
    x1: 62,
    y1: 138,
    x2: 103.597,
    y2: 185.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 138,
    fill: "white",
    transform: "translate(13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f1f934d3a87927e75d794e444cb810e.svg";
export { ForwardRef as ReactComponent };